import {
    Box,
    Container,
    Typography,
    Paper,
    CircularProgress,
    Alert,
    Button
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useVerifyEmail } from '../../react-query/auth-queries';
import { useEffect, useState } from 'react';
import { ROUTES } from '../../router/routes';

export default function VerifyEmailPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState('');
    
    const { mutateAsync: verifyEmail, isPending } = useVerifyEmail();

    useEffect(() => {
        if (!token) {
            setError('Missing verification token.');
            return;
        }
        
        // Prevent double call
        if (verified || error || isPending) return;

        verifyEmail(token)
            .then((response) => {
                if (response.success) {
                    setVerified(true);
                } else {
                    setError(response.message || 'Verification failed');
                }
            })
            .catch((err: any) => {
                console.error("Verification error:", err);
                setError(err.response?.data?.message || 'Verification failed');
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]); 
    // Effect depends on token. verifyEmail is mutation, better logic might be needed to avoid multiple calls, 
    // but React strict mode calls twice. The backend should handle idempotent, or verifyEmail might fail the second time if already verified.
    
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                py: 3,
                px: 2
            }}
        >
            <Container maxWidth="sm" >
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="h4" gutterBottom>
                        Email Verification
                    </Typography>
                    
                    {isPending && <CircularProgress sx={{ my: 4 }} />}
                    
                    {verified && (
                        <Box>
                            <Alert severity="success" sx={{ mb: 2 }}>
                                Email verified successfully!
                            </Alert>
                             <Button
                                variant="contained"
                                onClick={() => navigate(ROUTES.LOGIN.path)}
                            >
                                Go to Login
                            </Button>
                        </Box>
                    )}
                    
                    {error && (
                        <Box>
                             <Alert severity="error" sx={{ mb: 2 }}>
                                {error}
                            </Alert>
                             <Button
                                variant="outlined"
                                onClick={() => navigate(ROUTES.LOGIN.path)}
                            >
                                Go to Login
                            </Button>
                        </Box>
                    )}
                </Paper>
            </Container>
        </Box>
    );
}
